import './../App.css';
import { useEffect, useState, useRef } from 'react';
import greybg from "../img/greybg.jpg";
import backgrnd from "../img/bgPencil.jpg";
import Axios from 'axios'
import { apiUrl } from '../constants/Constants';
import LoadingBar from "react-top-loading-bar";
import RightArrow from '../img/right-arrow.svg';
import { nosValeurs } from '../constants/MyConstants';

const backgroundGrey = {
    backgroundImage: `url(${greybg})`,
    height: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};


function QuiSommeNous() {

    const ref = useRef(null);

    const handleLoadSomething = () => {
        ref.current.continuousStart();
    };




    useEffect(() => {
        handleLoadSomething();
        document.getElementById("nav-acceuil1").classList.remove('navSelected'); document.getElementById("nav-quisommenous1").classList.add('navSelected'); document.getElementById("nav-nosolutions1").classList.remove('navSelected'); document.getElementById("nav-carrieres1").classList.remove('navSelected'); document.getElementById("nav-contactez1").classList.remove('navSelected');
        document.getElementById("nav-acceuil").classList.remove('navSelected'); document.getElementById("nav-quisommenous").classList.add('navSelected'); document.getElementById("nav-nosolutions").classList.remove('navSelected'); document.getElementById("nav-carrieres").classList.remove('navSelected'); document.getElementById("nav-contactez").classList.remove('navSelected');

    }, [])




    return (
        <div className='overflow' id='mainQuiSommesNous'>
            <LoadingBar color="#009F6B" ref={ref} />

            <div className='background-img-medium2' style={{
                backgroundImage: "url(" + backgrnd + ")",
                backgroundSize: 'cover',
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <div class="col-md-12">
                    <div class=" text-center">
                        <div className='italic first-banner-title2 color-blue'>
                            People, Process, Productivity
                        </div>
                    </div>
                </div>
            </div>


            <div class="quisommenousContainer container">

                <div class="my-row my-row1">
                    <div>
                        <img class="img-full-QSN-top " src={require('../img/Image5_1060x708.png')} alt="" />
                    </div>
                    <div class="my-text1">
                        <div class="my-text-p color-blue bold">
                            Qui sommes-nous
                        </div>
                        <div class="qsn-first-section-p">
                            Créée en 2016, Pro-P-Group est un cabinet de conseil qui accompagne ses clients dans l’optimisation de leurs processus et la transformation digitale.</div>
                    </div>
                </div>

                <div class="my-row my-row2">
                    <div class="my-text2">
                        <div class="my-text-p color-blue bold">
                            Mission
                        </div>
                        <div class="qsn-first-section-p">
                            Proposer et développer des solutions optimales et de qualité à nos clients permettant d’améliorer le quotidien de l’utilisateur, de fiabiliser les résultats en sortie de leurs outils, d’avoir des indicateurs d’analyse pertinents tout en réduisant les coûts
                        </div></div>
                    <div>
                        <img class="image2 img-full-QSN-top " src={require('../img/lesSem_1_1060x708.jpg')} alt="" /></div>
                </div>
                <div class="my-row3">
                    <div class="my-text-p color-blue bold">
                        Pro-P vise à
                    </div>
                    
                    <div class=' qsn-list'>
                        <div class="qsn-flex">
                            <div><i class="fas fa-check"></i></div>
                            <div> Développer son activité en diversifiant son portefeuille par l’introduction de nouvelles solutions technologiques, inteldivgentes et modulaires </div>
                        </div>
                        <div class="qsn-flex">
                            <div><i class="fas fa-check"></i></div>
                            <div> Se développer dans le secteur d’assurance européen et le secteur bancaire français </div>
                        </div>
                        <div class="qsn-flex">
                            <div><i class="fas fa-check"></i></div>
                            <div> Créer de nouvelles opportunités pour les talents de la communauté locale </div>
                        </div> 
                        
                    </div>
                </div>
            </div>

            <div class="quisommenousContainer2 container">
                {/* text 1 */}
                <div class="my2-text1">
                    <div class="my2-text-p color-blue bold">
                        Qui sommes-nous
                    </div>
                    <div class="qsn-first-section-p">
                        Créée en 2016, Pro-P-Group est un cabinet de conseil qui accompagne ses clients dans l’optimisation de leurs processus et la transformation digitale.</div>

                </div>
                {/* text 1 */}
                <div >
                    <img class="image3" src={require('../img/Image5_1060x708.png')} alt="" />
                </div>
                {/* text 2 */}
                <div class="my2-text2">
                    <div class="my2-text-p color-blue bold">
                        Mission
                    </div>
                    <div class="qsn-first-section-p ">
                        Proposer et développer des solutions optimales et de qualité à nos clients permettant d’améliorer le quotidien de l’utilisateur, de fiabiliser les résultats en sortie de leurs outils, d’avoir des indicateurs d’analyse pertinents tout en réduisant les coûts
                    </div>
                </div>
                {/* text 2 */}

                <div>
                    <img class="image3" src={require('../img/lesSem_1_1060x708.jpg')} alt="" /></div>

                {/* text 3 */}
                <div class="my2-text3">
                    <div class="my2-text-p color-blue bold">
                        Pro-P vise à
                    </div>
                    <div class=' qsn-list2'>
                        <div class="qsn-flex">
                            <div><i class="fas fa-check"></i></div>
                            <div> Développer son activité en diversifiant son portefeuille par l’introduction de nouvelles solutions technologiques, inteldivgentes et modulaires </div>
                        </div>
                        <div class="qsn-flex">
                            <div><i class="fas fa-check"></i></div>
                            <div> Se développer dans le secteur d’assurance européen et le secteur bancaire français </div>
                        </div>
                        <div class="qsn-flex">
                            <div><i class="fas fa-check"></i></div>
                            <div>Créer de nouvelles opportunités pour les talents de la communauté locale </div>
                        </div>
                    </div>
                </div>
                {/* text 3 */}
            </div>
           

            <div class="container qsn-nosvaleurs">
                <div className='text-title color-blue bold'>Nos Valeurs</div>

                <div class="backgroundGreenDesign2 marginTop50 ">

                    {nosValeurs.map((data, index) => {
                        return (
                            <div key={index} class="insideGreen2 insideGreenAnimation">
                                <div class="shadow">
                                    <img class="shadowImg" src={data.image} alt="" />
                                </div>
                                <div class="displayFlex marginTop10">
                                    <div class="raleway nosValeurs-p color-blue bold">{data.text}&nbsp;</div>
                                    <div class="raleway nosValeurs-p color-blue insideGreen-span"> {data.span}</div>
                                </div>
                            </div>
                        )
                    })}

                </div>
            </div>

            <div class="scroll-top-icon scroll-top myscroll-top cursor-pointer" onClick={() => window.scrollTo({top: 0, left: 0, behavior: 'smooth' })}><i class="fa fa-angle-up fa-2x"></i></div>
        </div >


    );
}

export default QuiSommeNous;
